import axios from "axios";

const getClusterScanRecordListing = (payload) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/analytic/api/v1/dashboard/get-cluster-scan", {
        length: payload.length,
        start: payload.start,
        order: payload.order,
        order_by: payload.order_by,
        filter: {
          start_date: payload.start_date,
          end_date: payload.end_date,
          longitude: payload.longitude,
          latitude: payload.latitude,
          consumers: payload.consumers,
          status: payload.status,
          uuids: payload.uuids,
          isselectedall: payload.isselectedall,
        },
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
};

export default getClusterScanRecordListing;
